import { makeDeleteRequest } from 'owa-ows-gateway';
import { HttpStatusCode } from 'owa-http-status-codes';

const deleteAliasUrl: string = 'ows/api/beta/PremiumUser';

export async function deleteEmail(): Promise<Response> {
    var errorCode = null;

    await makeDeleteRequest(deleteAliasUrl, undefined, undefined, true)
        .then(response => {
            if (response.status === HttpStatusCode.OK) {
                return null;
            } else if (response.status === HttpStatusCode.BadRequest) {
                return response.json();
            } else {
                const unknownError = {
                    errorCode: '0',
                    message: 'unknown error',
                };

                return unknownError;
            }
        })
        .then(responseData => {
            if (responseData) {
                errorCode = responseData.errorCode;
            }
        });

    return errorCode;
}
